import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
import DeleteIcon from "./../../../Assets/Images/CommanImages/table_cross_icon.png";
import ReplaceIcon from "./../../../Assets/Images/CommanImages/tabler_replace-filled.png";
import EyeOpenIcon from "./../../../Assets/Images/CommanImages/eye_lock_open_icon.png";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import InfoIcon from "../../../Assets/Images/CommanImages/Informative.png";
import EyeLockIcon from "./../../../Assets/Images/CommanImages/eye-lock-icon.png";
import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";
import "./tab.css";

const TableComponent = ({
  headers,
  data,
  searchPlaceholder,
  renderQuestionText,
  handleRemoveRow,
  selectedSections,
  setSectionWiseQuestions,
  selecteSectionTypeID,
  handleReplaceRow,
  renderQuestionTextTable,
  selectedSectionPerRow,
  setSelectedSectionPerRow,
  isReadOnlyMode,
}) => {
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [averageRunTime, setAverageRunTime] = useState("");
  const columnDropdownRef = useRef(null);
  const [filters, setFilters] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  // const [selectedSectionPerRow, setSelectedSectionPerRow] = useState({});

  const generateSectionOptions = (selectedSections) => {
    return Array.from({ length: selectedSections }, (_, i) => {
      const label =
        selecteSectionTypeID === 2 ? `${i + 1}` : String.fromCharCode(65 + i); // ✅ numeric or alphabetic
      return {
        id: label,
        label: label,
      };
    });
  };

  const options = generateSectionOptions(selectedSections || 1);
  // useEffect(() => {
  //   if (data.length > 0 && selectedSections === 1) {
  //     const defaultSectionLabel = selecteSectionTypeID === 2 ? "1" : "A";

  //     const autoAssignDropdowns = {};
  //     const autoAssignSectionWise = { [defaultSectionLabel]: [] };

  //     data.forEach((row) => {
  //       const questionId = row[1];
  //       const questionText = row[2];

  //       autoAssignDropdowns[questionId] = defaultSectionLabel;
  //       autoAssignSectionWise[defaultSectionLabel].push({
  //         id: questionId,
  //         text: renderQuestionText(questionText),
  //       });
  //     });

  //     setSelectedSectionPerRow(autoAssignDropdowns);
  //     setSectionWiseQuestions?.(autoAssignSectionWise);
  //   } else if (selectedSections > 1) {
  //     // Clear previous auto-assignment if section count increased
  //     setSelectedSectionPerRow({});
  //     setSectionWiseQuestions({});
  //   }
  // }, [data, selectedSections, selecteSectionTypeID]);

  // useEffect(() => {
  //   if (headers.length > 0 && visibleColumns.length === 0) {
  //     const initialVisible = headers
  //       .slice(0, 6) // Get first 6 columns
  //       .filter((_, index) => index !== 4 && index !== 5); // Exclude index 4 and 5
  //     setVisibleColumns(initialVisible);
  //   }
  // }, [headers, visibleColumns]);
  // 
  
  
  {/* ✅ Fix: removed else if block — user manually selects section when multiple sections exist */}
  useEffect(() => {
    if (data.length > 0 && selectedSections === 1) {
      const defaultSectionLabel = selecteSectionTypeID === 2 ? "1" : "A";

      const autoAssignDropdowns = {};
      const autoAssignSectionWise = { [defaultSectionLabel]: [] };

      data.forEach((row) => {
        const questionId = row[1];
        const questionText = row[2];

        autoAssignDropdowns[questionId] = defaultSectionLabel;
        autoAssignSectionWise[defaultSectionLabel].push({
          id: questionId,
          text: renderQuestionText(questionText),
        });
      });

      setSelectedSectionPerRow(autoAssignDropdowns);
      setSectionWiseQuestions?.(autoAssignSectionWise);
    }
    // ✅ selectedSections > 1 par kuch mat karo — user manually select karega
  }, [data, selectedSections, selecteSectionTypeID]);


  useEffect(() => {
    if (headers.length > 0 && visibleColumns.length === 0) {
      const questionIdColumn = headers[1]; // Question ID at index 1
      const sectionColumn = headers[0]; // Section at index 0

      const initialVisible = headers
        .slice(0, 6) // Get first 6 columns
        .filter(
          (_, index) => index !== 4 && index !== 5 && index !== 0 // ✅ Exclude Section (index 0)
        );

      // Always include Section and Question ID
      const finalVisible = [sectionColumn, ...initialVisible];
      if (!finalVisible.includes(questionIdColumn)) {
        finalVisible.push(questionIdColumn);
      }

      setVisibleColumns(finalVisible);
    }
  }, [headers, visibleColumns]);

  // const handleColumnSelection = (column) => {
  //   if (visibleColumns.includes(column)) {
  //     setVisibleColumns(visibleColumns.filter((col) => col !== column));
  //   } else {
  //     setVisibleColumns([...visibleColumns, column]);
  //   }
  // };

  const handleColumnSelection = (column) => {
    const questionIdColumn = headers[1]; // Question ID at index 1
    const sectionColumn = headers[0]; // Section at index 0

    // Prevent toggling Section and Question ID
    if (column === questionIdColumn || column === sectionColumn) {
      return;
    }

    if (visibleColumns.includes(column)) {
      setVisibleColumns(visibleColumns.filter((col) => col !== column));
    } else {
      setVisibleColumns([...visibleColumns, column]);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleApplyFilter = () => {
    if (Object.keys(filters).length > 0) {
      setAppliedFilters({ ...filters }); // Persist selected filters
      setCurrentPage(1); // Reset to the first page
      setIsFiltersApplied(true); // Show Reset button
      setIsFilterVisible(false); // Hide the filter sidebar
    }
  };

  const handleResetFilter = () => {
    setFilters({}); // Clear current filter selections
    setAppliedFilters({}); // Clear applied filters
    setAverageRunTime(""); // Reset any other state if required
    setIsFiltersApplied(false); // Deactivate the Reset button
  };

  const filteredData = data.filter((row) => {
    const matchesSearchQuery = row.some(
      (cell) =>
        cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
    );
    const matchesAverageRunTime =
      averageRunTime === "" || row[2] === averageRunTime;

    // Apply appliedFilters
    const matchesFilters = Object.entries(appliedFilters).every(
      ([key, value]) => {
        const colIndex = headers.indexOf(key);
        return value ? row[colIndex] === value : true;
      }
    );

    return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
  });

  const handleSort = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        columnDropdownRef.current &&
        !columnDropdownRef.current.contains(event.target)
      ) {
        setIsColumnDivVisible(false); // Close the dropdown if clicked outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const sortedData = React.useMemo(() => {
    let sortableData = [...filteredData];
    if (sortConfig.key !== null) {
      const colIndex = headers.indexOf(sortConfig.key);
      sortableData.sort((a, b) => {
        if (a[colIndex] < b[colIndex]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[colIndex] > b[colIndex]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig, headers]);

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(sortedData.length / pageSize);
  const paginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return sortedData.slice(startIndex, startIndex + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            style={{ borderRadius: "5px" }}
            className={i === currentPage ? "active" : ""}
          >
            {" "}
            {i}{" "}
          </button>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pages.push(
            <button
              key={i}
              style={{ borderRadius: "5px" }}
              onClick={() => handlePageChange(i)}
              className={i === currentPage ? "active" : ""}
            >
              {" "}
              {i}{" "}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            {" "}
            ...{" "}
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            {" "}
            1{" "}
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            {" "}
            ...{" "}
          </span>
        );
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {" "}
              {i}{" "}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots2">
            {" "}
            ...{" "}
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {" "}
            {totalPages}{" "}
          </button>
        );
      } else {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            {" "}
            1{" "}
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            {" "}
            ...{" "}
          </span>
        );
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {" "}
              {i}{" "}
            </button>
          );
        }
      }
    }
    return pages;
  };
  const [columnWidth, setColumnWidth] = useState(400);
  const columnRef = useRef(null);
  const isResizing = useRef(false);

  const handleMouseDown = (event) => {
    isResizing.current = true;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (event) => {
    if (isResizing.current) {
      const newWidth = Math.max(
        100,
        event.clientX - columnRef.current.offsetLeft
      );
      setColumnWidth(newWidth);
    }
  };

  const handleMouseUp = () => {
    isResizing.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "1.5%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "80vw",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #6A6A6A",
              overflow: "hidden",
            }}
          >
            <input
              type="text"
              placeholder={searchPlaceholder}
              name="search"
              className="search-input-ques-dash"
              onChange={handleSearch}
            />
            <div
              style={{
                width: "1px",
                height: "24px",
                backgroundColor: "#2F2E40",
                margin: "0 4px",
              }}
            ></div>
            <img
              src={searchicon}
              alt="search"
              className="search-icon-ques-dash"
            />
          </div>
          <div
            style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
          >
            Displaying{" "}
            {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
            {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
            {sortedData.length} records |
            {["10", "25", "50", "100", "500"].map((size) => (
              <span
                key={size}
                onClick={() => handlePageSizeChange(Number(size))}
                style={{
                  cursor: "pointer",
                  margin: "0 5px",
                  textDecoration:
                    size === pageSize.toString() ? "none" : "underline",
                  color: size === pageSize.toString() ? "black" : "#337AB7",
                }}
              >
                {size}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          backgroundColor: "#D6D6D6",
          marginTop: "9px",
          borderTop: "1px solid grey",
          borderBottom: "1px solid grey",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFBD20",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            paddingLeft: "8px",
            width: "90px",
          }}
          onClick={() => setIsFilterVisible(!isFilterVisible)}
        >
          <img
            src={Filter}
            style={{ height: "24px", width: "24px" }}
            alt="filter"
          />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
        </div>
        <div
          style={{
            marginLeft: "auto",
            textAlign: "end",
            marginRight: "8px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            height: "40px",
          }}
          onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
        >
          <img
            src={columnaddition}
            style={{ height: "34px", width: "32px" }}
            alt="column addition"
          />
          <span
            style={{
              marginLeft: "4px",
              color: "#2F2E40",
              marginRight: "14px",
              fontSize: "14px",
            }}
          >
            Column Selection
          </span>
          {isColumnDivVisible && (
            <div ref={columnDropdownRef}>
              <div className="arrow-up-tc"></div>
              <div className="popupColumn-tc">
                {/* {headers
                  .filter((_, index) => index !== 4 && index !== 5) // Skip index 4 and 5
                  .map((column, index) => (
                    <div
                      key={index}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleColumnSelection(column);
                      }}
                    >
                      <input
                        type="checkbox"
                        id={`column-${index}`}
                        name="columnSelection"
                        value={column}
                        className="square-checkbox-tc"
                        checked={visibleColumns.includes(column)}
                        readOnly
                      />
                      <label htmlFor={`column-${index}`}>{column}</label>
                    </div>
                  ))} */}
                {headers
                  .filter(
                    (_, index) =>
                      index !== 0 && // ✅ Skip Section (index 0) from dropdown
                      index !== 4 &&
                      index !== 5
                  )
                  .map((column, index) => {
                    const originalIndex = headers.indexOf(column);
                    const isQuestionId = originalIndex === 1; // Check if it's Question ID

                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleColumnSelection(column);
                        }}
                        style={{
                          cursor: isQuestionId ? "not-allowed" : "pointer",
                          opacity: isQuestionId ? 0.7 : 1,
                        }}
                      >
                        <input
                          type="checkbox"
                          id={`column-${index}`}
                          name="columnSelection"
                          value={column}
                          className="square-checkbox-tc"
                          checked={visibleColumns.includes(column)}
                          disabled={isQuestionId}
                          readOnly
                        />
                        <label
                          htmlFor={`column-${index}`}
                          style={{
                            cursor: isQuestionId ? "not-allowed" : "pointer",
                          }}
                        >
                          {column}
                        </label>
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
        </div>
      </div>
      {data.length > 0 ? (
        <>
          <div className="table-wrapper-cols-selections-selected-ques-list">
            <table className="table-tc" style={{ width: "100%" }}>
              <thead>
                <tr>
                  {visibleColumns.map((heading, index) => (
                    <td
                      key={index}
                      ref={index === 1 ? columnRef : null}
                      className={`Heading-tc resizable-header ${
                        index === 1 ? "resizable-header" : ""
                      }`}
                      style={{
                        textAlign: "right",
                        cursor: "pointer",
                        width: index === 1 ? `${columnWidth}px` : "auto",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "left",
                          justifyContent: "left",
                          marginLeft: index === 0 ? "130px" : "",
                        }}
                      >
                        {heading}
                        {index === 2 && (
                          <div
                            className="resize-handle"
                            onMouseDown={handleMouseDown}
                          ></div>
                        )}
                        <img
                          onClick={() => handleSort(heading)}
                          src={updown}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "5px",
                          }}
                          alt="sort"
                        />
                      </span>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {/* {paginatedData.map((row, rowIndex) => ( */}
                {paginatedData.map((row, rowIndex) => {
                  const questionId = row[1]; // ✅ Index for Question ID
                  const questionText = row[2]; // ✅ Index for Question Text
                  return (
                    <tr
                      key={rowIndex}
                      className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
                    >
                      {visibleColumns.map((column, cellIndex) => (
                        <td
                          key={cellIndex}
                          style={{
                            width:
                              cellIndex === 3 ? `${columnWidth}px` : "100px",
                            textAlign: "left",
                            color: "#6A6A6A",
                            verticalAlign: "middle",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: `${columnWidth}px`,
                          }}
                        >
                          {cellIndex === 0 ? ( // Ensure link only appears once
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <div
                                className="flag-container-ques-bank-dash"
                                style={{
                                  width: "220px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "20px",
                                }}
                              >
                                <img
                                  src={DeleteIcon}
                                  alt="flag count"
                                  style={{
                                    width: "20px",
                                    opacity: isReadOnlyMode ? 0.6 : 1,
                                  }}
                                  // onClick={() => handleRemoveRow && handleRemoveRow(row)}
                                  onClick={() => {
                                    if (!isReadOnlyMode && handleRemoveRow) {
                                      handleRemoveRow(row);
                                    }
                                  }}
                                />
                                <img
                                  src={ReplaceIcon}
                                  alt="replace question"
                                  style={{
                                    width: "24px",
                                    cursor: "pointer",
                                    opacity: isReadOnlyMode ? 0.6 : 1,
                                  }}
                                  // onClick={() => handleReplaceRow(row)}
                                  onClick={() => {
                                    if (!isReadOnlyMode) {
                                      handleReplaceRow(row);
                                    }
                                  }}
                                />
                                <div style={{ width: "24px" }}>
                                  {row[4] === 13 && (
                                    <img
                                      src={EyeLockIcon}
                                      alt="replace question"
                                      style={{
                                        width: "24px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  )}
                                </div>
                                {/* <select
                                  style={{
                                    width: "70px",
                                    padding: "5px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    cursor: "pointer",
                                  }}
                                  value={
                                    selectedSectionPerRow[questionId] || ""
                                  }
                                  onChange={(e) => {
                                    const sectionLabel = e.target.value;
                                    setSelectedSectionPerRow((prev) => ({
                                      ...prev,
                                      [questionId]: sectionLabel,
                                    }));

                                    setSectionWiseQuestions?.((prev) => {
                                      const updated = { ...prev };

                                      // Remove this question from all sections
                                      for (const sec in updated) {
                                        updated[sec] = updated[sec].filter(
                                          (q) => q.id !== questionId
                                        );
                                      }

                                      // Add to new section
                                      if (sectionLabel) {
                                        if (!updated[sectionLabel])
                                          updated[sectionLabel] = [];
                                        updated[sectionLabel].push({
                                          id: questionId,
                                          text: questionText,
                                        });
                                      }
                                      return updated;
                                    });
                                  }}
                                  disabled={isReadOnlyMode}
                                >
                                  <option value="">Select</option>
                                  {options.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.label}
                                    </option>
                                  ))}
                                </select> */} 

                                {/* ✅ Mac fix: onInput added for Safari/Chrome compatibility */}
                                <select
                                  style={{
                                    width: "70px",
                                    padding: "5px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    cursor: "pointer",
                                  }}
                                  value={
                                    selectedSectionPerRow[questionId] || ""
                                  }
                                  onChange={(e) => {
                                    const sectionLabel = e.target.value;
                                    setSelectedSectionPerRow((prev) => ({
                                      ...prev,
                                      [questionId]: sectionLabel,
                                    }));
                                    setSectionWiseQuestions?.((prev) => {
                                      const updated = { ...prev };
                                      for (const sec in updated) {
                                        updated[sec] = updated[sec].filter(
                                          (q) => q.id !== questionId
                                        );
                                      }
                                      if (sectionLabel) {
                                        if (!updated[sectionLabel])
                                          updated[sectionLabel] = [];
                                        updated[sectionLabel].push({
                                          id: questionId,
                                          text: questionText,
                                        });
                                      }
                                      return updated;
                                    });
                                  }}
                                  onInput={(e) => {
                                    const sectionLabel = e.target.value;
                                    if (!sectionLabel) return;
                                    if (selectedSectionPerRow[questionId] === sectionLabel) return;
                                    setSelectedSectionPerRow((prev) => ({
                                      ...prev,
                                      [questionId]: sectionLabel,
                                    }));
                                    setSectionWiseQuestions?.((prev) => {
                                      const updated = { ...prev };
                                      for (const sec in updated) {
                                        updated[sec] = updated[sec].filter(
                                          (q) => q.id !== questionId
                                        );
                                      }
                                      if (!updated[sectionLabel])
                                        updated[sectionLabel] = [];
                                      updated[sectionLabel].push({
                                        id: questionId,
                                        text: questionText,
                                      });
                                      return updated;
                                    });
                                  }}
                                  disabled={isReadOnlyMode}
                                >
                                  <option value="">Select</option>
                                  {options.map((option) => (
                                    <option key={option.id} value={option.id}>
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <Link style={{ color: "#337ab7" }}>
                                <span
                                  className="truncated-text"
                                  title={row[headers.indexOf(column)]}
                                >
                                  {" "}
                                  {headers.indexOf(column) === 2
                                    ? renderQuestionTextTable(
                                        row[headers.indexOf(column)]
                                      )
                                    : row[headers.indexOf(column)]}{" "}
                                </span>
                              </Link>
                            </div>
                          ) : (
                            <span className="truncated-text-2">
                              {" "}
                              {headers.indexOf(column) === 2
                                ? renderQuestionTextTable(
                                    row[headers.indexOf(column)]
                                  )
                                : row[headers.indexOf(column)]}{" "}
                            </span>
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="pagination-tc">
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
              className="extreme-left-tc-pagination"
            >
              {" "}
              <img src={leftArrow} alt="" />{" "}
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="lefttc-pagination"
            >
              {" "}
              {"<"}
            </button>{" "}
            {renderPagination()}{" "}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="righttc-pagination"
            >
              {" "}
              {">"}{" "}
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
              className="extreme-right-tc-pagination"
            >
              {" "}
              <img src={rightArrow} alt="" />{" "}
            </button>
          </div>
        </>
      ) : (
        "No data available"
      )}
      {isFilterVisible && (
        <div className="filter-sidebar-tc">
          <div className="filter-content-tc" style={{ position: "relative" }}>
            <button
              className="repman-cross-btn"
              onClick={() => {
                setIsFilterVisible(false);
              }}
            >
              {" "}
              <p>X</p>{" "}
            </button>
            <h3 className="AdvanceF-heading-tc"> Filter</h3>
            <div className="filter-apply-reset-ques-rev-dash">
              {isFiltersApplied && (
                <button
                  className="reset-btn-question-review-dash"
                  onClick={handleResetFilter}
                >
                  {" "}
                  RESET{" "}
                </button>
              )}
              <button
                className="apply-btn-question-review-dash"
                onClick={handleApplyFilter}
              >
                {" "}
                APPLY{" "}
              </button>
            </div>
            <div className="filter-options-container">
              {headers
                .filter((_, index) => index === 0 || index >= 3) // Skip index 2 and 4
                .map((header, filteredIndex) => {
                  const originalIndex =
                    filteredIndex === 0
                      ? 0
                      : filteredIndex + 1 + (filteredIndex >= 1 ? 1 : 0);
                  let uniqueOptions = [
                    ...new Set(
                      data
                        .map((row) => row[originalIndex])
                        .filter((option) => option)
                    ),
                  ];
                  if (originalIndex === 0 || originalIndex === 6) {
                    uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
                  }
                  return (
                    <SelectedValuesDropdown
                      key={originalIndex}
                      label={header}
                      width="300px"
                      marginLeft="15px"
                      marginTop="18px"
                      setSelected={(selectedOption) => {
                        setFilters((prevFilters) => ({
                          ...prevFilters,
                          [header]: selectedOption,
                        }));
                      }}
                      options={uniqueOptions.map((value) => ({
                        label: value,
                        id: value,
                      }))}
                      selected={filters[header] || ""}
                      Height="auto"
                      OverFlow="auto"
                      minheight="200px"
                    />
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const TableDetailsSelectedQuestions = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
  selectedSections,
  setQuestionIds,
  activeSubjectId,
  setSectionWiseQuestions,
  selecteSectionTypeID,
  // tableQuestions,
  allQuesList,
  draftData,
  isReadOnlyMode,
  setDifficultyCount,
  version,
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [selectedSectionPerRow, setSelectedSectionPerRow] = useState({});
  const [draftLoaded, setDraftLoaded] = useState(false);

  const renderQuestionTextTable = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2">
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  const renderQuestionText = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2">
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  // useEffect(() => {
  //   const fetchSelectedQuestions = async () => {
  //     const subjectWiseSelected = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
  //     const localSubjectIds = subjectWiseSelected[activeSubjectId] || [];

  //     const draftSubjectQuestions = draftData?.subjects?.find(subject => subject.subject_id === activeSubjectId)?.questions?.filter(q => q.status === 1) || [];
  //     const draftSubjectIds = draftSubjectQuestions.map(q => q.parse_ques_set_question_id);
  //     // console.log(draftSubjectIds, "draftSubjectIds in TableDetailsSelectedQuestions");

  //     const mergedIds = Array.from(new Set([...localSubjectIds, ...draftSubjectIds]));
  //     if (mergedIds.length === 0) return;

  //     try {
  //       const response = await fetch(`${FULL_API_BASE_URL}/get-questions-by-ids`, {
  //         method: "POST",
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("other")}`,
  //           Accept: "application/json",
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(mergedIds),
  //       });

  //       const result = await response.json();
  //       const tableData = result?.data?.table_data || [];

  //       if (tableData.length > 1) {
  //         const headers = tableData[0].map(h => h.replace(/^t\*|d\*|n\*/, ""));
  //         const rows = tableData.slice(1);
  //         setHeaders(["Section", ...headers]);
  //         setReportDashboardData(rows.map(row => ["", ...row]));

  //         const allIds = rows.map(row => row[0]);
  //         const existing = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
  //         const updated = {
  //           ...existing,
  //           [activeSubjectId]: Array.from(new Set([...(existing[activeSubjectId] || []), ...allIds])),
  //         };
  //         localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(updated));
  //         setDraftLoaded(true);
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch selected questions:", error);
  //     }
  //   };

  //   fetchSelectedQuestions();
  // }, [draftData, activeSubjectId, version]);

  // useEffect(() => {
  //   if (!reportDashboardData.length || !draftLoaded) return;
  //   const difficultyIndex = headers.findIndex(h => h.toLowerCase().includes("difficulty level"));
  //   const difficultyCount = { easy: 0, medium: 0, tough: 0 };
  //   reportDashboardData.forEach(row => {
  //     const diff = row[difficultyIndex]?.toLowerCase();
  //     if (["easy", "medium", "tough"].includes(diff)) difficultyCount[diff]++;
  //   });
  //   setDifficultyCount?.(difficultyCount);
  // }, [reportDashboardData, headers, draftLoaded]);

  useEffect(() => {
    const difficultyIndex = headers.findIndex((h) =>
      h.toLowerCase().includes("difficulty level")
    );

    const difficultyCount = { easy: 0, medium: 0, tough: 0 };

    if (reportDashboardData.length && draftLoaded) {
      reportDashboardData.forEach((row) => {
        const diff = row[difficultyIndex]?.toLowerCase();
        if (["easy", "medium", "tough"].includes(diff)) {
          difficultyCount[diff]++;
        }
      });
    }
    setDifficultyCount?.(difficultyCount);
  }, [reportDashboardData, headers, draftLoaded, activeSubjectId]);

  const quesTypeMapping = {
    "Single Correct MCQ": 1,
    "Multi Correct MCQ": 2,
    "Fill in the blanks": 3,
    "True/False": 4,
  };

  // Additional function to fetch selected questions based on activeSubjectId and draftData(SHASHI ON FRIDAY 30/05 2025)
  const fetchSelectedQuestions = async () => {
    const subjectWiseSelected = JSON.parse(
      localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
    );
    const deletedRowMap = JSON.parse(
      localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
    );

    const localSubjectIds = subjectWiseSelected[activeSubjectId] || [];

    // const draftSubjectQuestions = draftData?.subjects?.find(
    //   (subject) => subject.subject_id === activeSubjectId
    // )?.questions?.filter((q) => q.status === 1) || [];

    const draftSubjectQuestionsRaw =
      draftData?.subjects?.find(
        (subject) => subject.subject_id === activeSubjectId
      )?.questions || [];

    const draftSubjectQuestions = draftSubjectQuestionsRaw.filter(
      (q) => q.status === 1
    );
    const draftSubjectDeletedQuestions = draftSubjectQuestionsRaw.filter(
      (q) => q.status === 2
    );

    const draftSubjectIds = draftSubjectQuestions.map(
      (q) => q.parse_ques_set_question_id
    );
    const deletedDraftIds = draftSubjectDeletedQuestions.map(
      (q) => q.parse_ques_set_question_id
    );

    // const draftSubjectIds = draftSubjectQuestions.map((q) => q.parse_ques_set_question_id);

    // Merge and deduplicate
    const mergedIds = Array.from(
      new Set([...localSubjectIds, ...draftSubjectIds])
    );

    // ✅ Remove deleted IDs
    const deletedIds = deletedRowMap[activeSubjectId] || [];
    const finalIds = mergedIds.filter((id) => !deletedIds.includes(id));

    if (finalIds.length === 0) {
      setReportDashboardData([]);
      setHeaders([]);
      return;
    }

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-questions-by-ids`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("other")}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(finalIds),
        }
      );

      const result = await response.json();
      const tableData = result?.data?.table_data || [];

      if (tableData.length > 1) {
        const headers = tableData[0].map((h) => h.replace(/^t\*|d\*|n\*/, ""));
        const rows = tableData.slice(1);
        setHeaders(["Section", ...headers]);
        // setReportDashboardData(rows.map((row) => ["", ...row]));

        // Ensure table rows follow the order of `finalIds`
        const idToRowMap = new Map();
        rows.forEach((row) => {
          const quesId = row[0]; // assuming 0 is Question ID (since headers have ["Section", ...])
          idToRowMap.set(quesId, row);
        });

        const orderedRows = finalIds
          .map((id) => idToRowMap.get(id))
          .filter((row) => row); // skip if not found
        setReportDashboardData(orderedRows.map((row) => ["", ...row])); // add empty section as first column

        // ✅ Auto-assign default section (A/1) when selecting questions for the first time if only one section exists
        if (selectedSections === 1) {
          const defaultSection = selecteSectionTypeID === 2 ? "1" : "A";
          const newSectionMap = {};

          orderedRows.forEach((row) => {
            const questionId = row[0]; // before "Section" column
            newSectionMap[questionId] = defaultSection;
          });

          setSelectedSectionPerRow(newSectionMap);

          // Also build sectionWiseQuestions
          const sectionQuesMap = {
            [defaultSection]: orderedRows.map((row) => ({
              id: row[0],
              text: renderQuestionTextTable(row[2]),
            })),
          };
          setSectionWiseQuestions(sectionQuesMap);
        }

        const quesTypeMapPerSubject = {}; // New variable
        const questionTypeIndex = headers.findIndex((h) =>
          h.toLowerCase().includes("question type")
        );
        if (questionTypeIndex !== -1) {
          rows.forEach((row) => {
            const quesId = row[0]; // First column is Question ID (after Section)
            const quesTypeText = row[questionTypeIndex];
            const quesTypeId = quesTypeMapping[quesTypeText] || null;

            if (quesTypeId !== null) {
              quesTypeMapPerSubject[quesId] = quesTypeId;
            }
          });

          // ✅ Save as a new key in localStorage
          const existingTypeMap = JSON.parse(
            localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
          );
          localStorage.setItem(
            "subjectWiseQuesTypeIds",
            JSON.stringify({
              ...existingTypeMap,
              [activeSubjectId]: quesTypeMapPerSubject,
            })
          );
        }

        // ✅ Update localStorage: merge both
        const existing = JSON.parse(
          localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
        );
        localStorage.setItem(
          "subjectWiseSelectedRowIds",
          JSON.stringify({
            ...existing,
            [activeSubjectId]: finalIds,
          })
        );

        // ✅ Save deleted question IDs (status 2) in localStorage
        // const existingDeleted = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds") || "{}");
        // localStorage.setItem("subjectWiseDeletedRowIds", JSON.stringify({
        //   ...existingDeleted,
        //   [activeSubjectId]: deletedDraftIds,
        // }));

        const existingDeleted = JSON.parse(
          localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
        );
        const currentSelected =
          JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}")[
            activeSubjectId
          ] || [];

        const mergedDeletedIds = deletedDraftIds.filter(
          (id) => !currentSelected.includes(id)
        ); // ✅ do not save as deleted if user already reselected

        localStorage.setItem(
          "subjectWiseDeletedRowIds",
          JSON.stringify({
            ...existingDeleted,
            [activeSubjectId]: mergedDeletedIds,
          })
        );
        setDraftLoaded(true);
      }
    } catch (error) {
      console.error("Failed to fetch selected questions:", error);
    }
  };

  useEffect(() => {
    fetchSelectedQuestions();
  }, [activeSubjectId, draftData, version]);

  // Save selectedSectionPerRow to localStorage every time it updates
  useEffect(() => {
    if (
      !selectedSectionPerRow ||
      Object.keys(selectedSectionPerRow).length === 0
    )
      return;

    const existingMap = JSON.parse(
      localStorage.getItem("subjectWiseSectionMap") || "{}"
    );
    localStorage.setItem(
      "subjectWiseSectionMap",
      JSON.stringify({
        ...existingMap,
        [activeSubjectId]: selectedSectionPerRow,
      })
    );
  }, [selectedSectionPerRow, activeSubjectId]);

  // Restore selectedSectionPerRow and sectionWiseQuestions from localStorage
  useEffect(() => {
    const savedMap = JSON.parse(
      localStorage.getItem("subjectWiseSectionMap") || "{}"
    );
    const subjectMap = savedMap[activeSubjectId] || {};

    setSelectedSectionPerRow(subjectMap); // 🟢 restore dropdowns

    const newSectionWise = {};
    reportDashboardData.forEach((row) => {
      const quesId = row[1];
      const section = subjectMap[quesId];
      if (section) {
        if (!newSectionWise[section]) newSectionWise[section] = [];
        newSectionWise[section].push({
          id: quesId,
          text: renderQuestionTextTable(row[2]),
        });
      }
    });

    setSectionWiseQuestions(newSectionWise); // 🟢 restore section mapping
  }, [reportDashboardData, draftLoaded, activeSubjectId]);

  // useEffect(() => {
  //   if (!reportDashboardData.length || !draftLoaded) return;

  //   const subject = draftData?.subjects?.find(s => s.subject_id === activeSubjectId);
  //   const dropdownMap = {};

  //   subject?.questions?.forEach(q => {
  //     if (q.status === 1 && q.section_name) {
  //       dropdownMap[q.parse_ques_set_question_id] = q.section_name;
  //     }
  //   });

  //   setSelectedSectionPerRow(dropdownMap); // ✅ THIS LINE SETS DROPDOWN DEFAULT VALUES
  // }, [reportDashboardData, draftData, activeSubjectId, draftLoaded]);

  // This effect sets the section-wise questions map based on reportDashboardData and draftData
  // useEffect(() => {
  //   if (!reportDashboardData.length || !draftLoaded) return;

  //   const subject = draftData?.subjects?.find(s => s.subject_id === activeSubjectId);
  //   const dropdownMap = {};
  //   const sectionMap = {};

  //   subject?.questions?.forEach(q => {
  //     if (q.status === 1 && q.section_name) {
  //       const quesId = q.parse_ques_set_question_id;
  //       const section = q.section_name;

  //       dropdownMap[quesId] = section;

  //       const matchingRow = reportDashboardData.find(r => r[1] === quesId);
  //       const questionText = matchingRow?.[2] || ""; // 👈 take from reportDashboardData

  //       if (!sectionMap[section]) sectionMap[section] = [];
  //       sectionMap[section].push({
  //         id: quesId,
  //         text: renderQuestionTextTable(questionText), // ✅ make sure text is added here
  //       });
  //     }
  //   });

  //   setSelectedSectionPerRow(dropdownMap);
  //   setSectionWiseQuestions(sectionMap); // ✅ key part
  // }, [reportDashboardData, draftData, activeSubjectId, draftLoaded]);

  useEffect(() => {
    if (!reportDashboardData.length || !draftLoaded) return;

    const subject = draftData?.subjects?.find(
      (s) => s.subject_id === activeSubjectId
    );
    const dropdownMap = {};

    subject?.questions?.forEach((q) => {
      if (q.status === 1 && q.section_name) {
        const quesId = q.parse_ques_set_question_id;
        dropdownMap[quesId] = q.section_name;
      }
    });

    // 🧠 Merge draft (dropdownMap) + localStorage map
    const savedMap = JSON.parse(
      localStorage.getItem("subjectWiseSectionMap") || "{}"
    );
    const savedSubjectMap = savedMap[activeSubjectId] || {};

    const mergedMap = {
      ...dropdownMap, // from draft
      ...savedSubjectMap, // from previously saved manual changes
    };

    setSelectedSectionPerRow(mergedMap);

    // 🧠 Auto-assign section if none exists and only one section add this logic on Monday 14/07/2025
    const finalMap = { ...mergedMap };
    const defaultSection = selecteSectionTypeID === 2 ? "1" : "A";

    if (selectedSections === 1) {
      reportDashboardData.forEach((row) => {
        const quesId = row[1];
        if (!finalMap[quesId]) {
          finalMap[quesId] = defaultSection;
        }
      });
    }

    setSelectedSectionPerRow(finalMap);

    // 💾 Save merged version back
    localStorage.setItem(
      "subjectWiseSectionMap",
      JSON.stringify({
        ...savedMap,
        [activeSubjectId]: mergedMap,
      })
    );

    // 🛠 Build sectionWiseQuestions from merged map
    const sectionMap = {};
    reportDashboardData.forEach((row) => {
      const quesId = row[1];
      const section = mergedMap[quesId];
      if (section) {
        if (!sectionMap[section]) sectionMap[section] = [];
        sectionMap[section].push({
          id: quesId,
          text: renderQuestionTextTable(row[2]),
        });
      }
    });

    setSectionWiseQuestions(sectionMap);
  }, [reportDashboardData, draftData, activeSubjectId, draftLoaded]);

  const handleRemoveRow = (rowToDelete) => {
    const questionId = rowToDelete[1];
    // Remove from UI
    const updatedData = reportDashboardData.filter(
      (row) => row[1] !== questionId
    );
    setReportDashboardData(updatedData);

    // ✅ Remove from subjectWiseSelectedRowIds
    const selectedMap = JSON.parse(
      localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
    );
    const updatedSelected = (selectedMap[activeSubjectId] || []).filter(
      (id) => id !== questionId
    );
    localStorage.setItem(
      "subjectWiseSelectedRowIds",
      JSON.stringify({
        ...selectedMap,
        [activeSubjectId]: updatedSelected,
      })
    );

    // ✅ Add to subjectWiseDeletedRowIds
    const deletedMap = JSON.parse(
      localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
    );
    const updatedDeleted = Array.from(
      new Set([...(deletedMap[activeSubjectId] || []), questionId])
    );
    localStorage.setItem(
      "subjectWiseDeletedRowIds",
      JSON.stringify({
        ...deletedMap,
        [activeSubjectId]: updatedDeleted,
      })
    );

    // ✅ Update difficulty count
    const difficultyIndex = headers.findIndex((h) =>
      h.toLowerCase().includes("difficulty level")
    );
    const diff = rowToDelete[difficultyIndex]?.toLowerCase();
    if (["easy", "medium", "tough"].includes(diff)) {
      setDifficultyCount((prev) => ({
        ...prev,
        [diff]: Math.max(0, (prev?.[diff] || 0) - 1),
      }));
    }
  };

  const handleReplaceRow = (rowToReplace) => {
    const questionIdIndex = 1; // in reportDashboardData
    const currentQuesId = rowToReplace[questionIdIndex];

    // ✅ Find this question in allQuesList to get correct Group ID
    const matchedRow = allQuesList.find((r) => r[0] === currentQuesId);
    // if (!matchedRow) {
    //   console.warn("❌ No matching row found in allQuesList for ID:", currentQuesId);
    //   return;
    // }
    if (!matchedRow) {
      // console.warn("❌ No matching row found in allQuesList for ID:", currentQuesId);

      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              This question is missing from the current question set and cannot
              be replaced.
            </span>
          </div>
        </div>
      );
      return;
    }
    const groupIdIndexInAll =
      headers.findIndex((h) => h.toLowerCase().includes("group id")) - 1; // -1 because allQuesList doesn't have "Section"
    const currentGroupId = matchedRow[groupIdIndexInAll];

    // ✅ Find this question's type so the replacement matches it
    const quesTypeIndexInAll =
      headers.findIndex((h) => h.toLowerCase().includes("question type")) - 1; // -1 because allQuesList doesn't have "Section"
    const currentQuesType = matchedRow[quesTypeIndexInAll];

    console.log("✅ Correct Group ID from allQuesList:", currentGroupId);
    console.log("✅ Current Question Type:", currentQuesType);

    const selectedMap = JSON.parse(
      localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
    );
    const selectedIds = selectedMap[activeSubjectId] || [];

    // ✅ Get same-group rows (excluding current and already selected) that match the same question type
    const sameGroupRows = allQuesList.filter(
      (r) =>
        r[groupIdIndexInAll] === currentGroupId &&
        r[0] !== currentQuesId &&
        !selectedIds.includes(r[0]) &&
        r[quesTypeIndexInAll] === currentQuesType
    );

    console.log(
      "🔄 Replacement candidates:",
      sameGroupRows.map((r) => r[0])
    );

    if (sameGroupRows.length === 0) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            {/* <span>No replacement found for the same Group ID.</span> */}
            <span>
              No available "{currentQuesType}" questions in the list to replace
              the selected question.
            </span>
          </div>
        </div>
      );
      return;
    }

    const replacementRow = sameGroupRows[0];

    // ✅ Replace row in reportDashboardData
    const updatedData = reportDashboardData.map((row) =>
      row[questionIdIndex] === currentQuesId ? [row[0], ...replacementRow] : row
    );
    setReportDashboardData(updatedData);

    // ✅ Update localStorage IDs
    const updatedIds = selectedIds
      .filter((id) => id !== currentQuesId)
      .concat(replacementRow[0]);
    localStorage.setItem(
      "subjectWiseSelectedRowIds",
      JSON.stringify({
        ...selectedMap,
        [activeSubjectId]: updatedIds,
      })
    );

    // ✅ Update question type map
    const quesTypeText =
      replacementRow[
        headers.findIndex((h) => h.toLowerCase().includes("question type")) - 1
      ]; // -1 because we added "Section"
    const quesTypeId = quesTypeMapping[quesTypeText] || null;

    if (quesTypeId !== null) {
      const existingQuesTypeMap = JSON.parse(
        localStorage.getItem("subjectWiseQuesTypeIds") || "{}"
      );
      const updatedQuesTypeMap = {
        ...(existingQuesTypeMap[activeSubjectId] || {}),
        [replacementRow[0]]: quesTypeId,
      };

      // Remove old ID
      delete updatedQuesTypeMap[currentQuesId];

      localStorage.setItem(
        "subjectWiseQuesTypeIds",
        JSON.stringify({
          ...existingQuesTypeMap,
          [activeSubjectId]: updatedQuesTypeMap,
        })
      );
    }
    console.log("✅ Replacement successful:", replacementRow[0]);
  };

  return (
    <div style={{ height: "auto", width: "100%" }}>
      <div style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
        <TableComponent
          headers={headers}
          data={reportDashboardData}
          searchPlaceholder="Filter Questions..."
          dataClient={dataClient}
          setPagePath={setPagePath}
          renderQuestionText={renderQuestionText}
          handleRemoveRow={handleRemoveRow}
          selectedSections={selectedSections}
          setIsMessageBoxVisible={setIsMessageBoxVisible}
          setMessageBox={setMessageBox}
          setActiveImg={setActiveImg}
          setSectionWiseQuestions={setSectionWiseQuestions}
          selecteSectionTypeID={selecteSectionTypeID}
          setQuestionIds={setQuestionIds}
          // tableQuestions={tableQuestions}
          allQuesList={allQuesList}
          handleReplaceRow={handleReplaceRow}
          renderQuestionTextTable={renderQuestionTextTable}
          selectedSectionPerRow={selectedSectionPerRow}
          setSelectedSectionPerRow={setSelectedSectionPerRow}
          isReadOnlyMode={isReadOnlyMode}
        />
      </div>
    </div>
  );
};

export default TableDetailsSelectedQuestions;

//   const handleRemoveRow = (rowToDelete) => {
//   const questionId = rowToDelete[1]; // row[1] is the question ID
//   const updatedData = reportDashboardData.filter(row => row[1] !== questionId);
//   setReportDashboardData(updatedData);

//   // Update selectedRowIds in localStorage
//   const existing = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//   const updatedIds = (existing[activeSubjectId] || []).filter(id => id !== questionId);
//   localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify({
//     ...existing,
//     [activeSubjectId]: updatedIds,
//   }));

//   // Optionally update difficulty count
//   const difficultyIndex = headers.findIndex(h => h.toLowerCase().includes("difficulty level"));
//   const diff = rowToDelete[difficultyIndex]?.toLowerCase();
//   if (["easy", "medium", "tough"].includes(diff)) {
//     setDifficultyCount((prev) => ({
//       ...prev,
//       [diff]: Math.max(0, prev[diff] - 1),
//     }));
//   }
// };

// const handleReplaceRow = (rowToReplace) => {
//   const questionIdIndex = 1;
//   const groupIdIndex = headers.findIndex(h => h.toLowerCase().includes("group id"));
//   const currentQuesId = rowToReplace[questionIdIndex];
//   const currentGroupId = rowToReplace[groupIdIndex];

//   const selectedIds = (JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}")[activeSubjectId] || []);
//   const sameGroupRows = allQuesList.filter(row => row[groupIdIndex - 1] === currentGroupId); // ✅ Subtract 1 because allQuesList doesn't have "Section"

//   const replacementCandidates = sameGroupRows.filter(
//     (row) => row[0] !== currentQuesId && !selectedIds.includes(row[0])
//   );

//   if (replacementCandidates.length === 0) {
//     setIsMessageBoxVisible(true);
//     setActiveImg(ErrorImg);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>No replacement found for the same Group ID.</span>
//         </div>
//       </div>
//     );
//     return;
//   }

//   const replacementRow = replacementCandidates[0];

//   // Replace in UI
//   const updated = reportDashboardData.map((row) =>
//     row[questionIdIndex] === currentQuesId ? [row[0], ...replacementRow] : row
//   );
//   setReportDashboardData(updated);

//   // Update localStorage
//   const map = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//   const updatedIds = map[activeSubjectId].filter(id => id !== currentQuesId).concat(replacementRow[0]);
//   localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify({ ...map, [activeSubjectId]: updatedIds }));
// };

// const TableDetailsSelectedQuestions = ({ setMessageBox, setIsMessageBoxVisible, setActiveImg, dataClient,
//   setPagePath, selectedQuestions, selectedHeaders, selectedSections, setQuestionIds, activeSubjectId,
//   setSectionWiseQuestions, selecteSectionTypeID, tableQuestions, allQuesList, setSelectedQuestions, draftData, isReadOnlyMode, setDifficultyCount }) => {
//   const [reportDashboardData, setReportDashboardData] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [deletedRows, setDeletedRows] = useState([]);
//   const [selectedSectionPerRow, setSelectedSectionPerRow] = useState({});
//  console.log(selectedQuestions, "setSelectedQuestions in TableDetailsSelectedQuestions");

//   const renderQuestionTextTable = (questionText) => {
//     const decodedQuestion = he.decode(questionText);
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         const img = new Image();
//         img.src = imageUrl;
//         img.onload = () => { };
//         return (
//           <img key={index} src={imageUrl} alt={`Question Image ${index}`} style={{ width: "30px", height: "auto", margin: "5px" }} />
//         );
//       } else {
//         return (
//           <span key={index} className="truncated-text-2"> <Latex>{segment}</Latex> </span>
//         );
//       }
//     });
//   };

//   const QuestionImage = ({ src, index }) => {
//     const [imgSize, setImgSize] = React.useState({ width: 0, height: 0 });

//     React.useEffect(() => {
//       const img = new Image();
//       img.src = src;
//       img.onload = () => {
//         console.log(`Image dimensions: ${img.width}px x ${img.height}px`);
//         setImgSize({ width: img.width, height: img.height });
//       };
//     }, [src]);

//     const style =
//       imgSize.width > 100 || imgSize.height > 100
//         ? { width: "auto", height: "100px", margin: "5px" }
//         : { width: "auto", height: "auto", margin: "5px" };

//     return <img key={index} src={src} alt={`Question Image ${index}`} style={style} />;
//   };

//   const renderQuestionText = (questionText) => {
//     const decodedQuestion = he.decode(questionText);
//     const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);

//     return questionSegments.map((segment, index) => {
//       if (segment.startsWith("imgsrc=")) {
//         const imageUrl = segment.replace("imgsrc=", "");
//         return <QuestionImage key={index} src={imageUrl} index={index} />;
//       } else {
//         return (
//           <span key={index} className="truncated-text-2">
//             <Latex>{segment}</Latex>
//           </span>
//         );
//       }
//     });
//   };

// //   useEffect(() => {
// //   const fetchSelectedQuestionsFromLocalStorage = async () => {
// //     const selectedRowIds = JSON.parse(localStorage.getItem("selectedRowIds") || "[]");
// //     if (selectedRowIds.length === 0) return;

// //     try {
// //       const response = await fetch(`${FULL_API_BASE_URL}/get-questions-by-ids`, {
// //         method: "POST",
// //         headers: {
// //           Authorization: `Bearer ${localStorage.getItem("other")}`,
// //           Accept: "application/json",
// //           "Content-Type": "application/json",
// //         },
// //         body: JSON.stringify(selectedRowIds),
// //       });

// //       const result = await response.json();
// //       const tableData = result?.data?.table_data || [];

// //       if (tableData.length > 1) {
// //         const rows = tableData.slice(1);
// //         setSelectedQuestions(rows); // ✅ Important: set into state
// //       }
// //     } catch (error) {
// //       console.error("Error fetching questions by IDs:", error);
// //     }
// //   };

// //   if (!selectedQuestions || selectedQuestions.length === 0) {
// //     fetchSelectedQuestionsFromLocalStorage();
// //   }
// // }, []);

//   // useEffect(() => {
//   //   if (!selectedQuestions || selectedQuestions.length === 0) return;
//   //   console.log("Selected Questions:", selectedQuestions);
//   //   const transformedRows = selectedQuestions
//   //     .map((row) => (Array.isArray(row) ? ["", ...row] : row))
//   //     .filter((row) => !deletedRows.includes(JSON.stringify(row)));

//   //   const headersWithSection = !selectedHeaders.includes("Section")
//   //     ? ["Section", ...selectedHeaders]
//   //     : selectedHeaders;

//   //   setHeaders(headersWithSection);
//   //   setReportDashboardData(transformedRows);
//   // }, [selectedQuestions, selectedHeaders, deletedRows]);

//   // useEffect(() => {
//   //   if (reportDashboardData.length > 0 && headers.length > 0) {
//   //     const idIndex = headers.findIndex(h =>
//   //       h.toLowerCase().includes("parse_ques_set_question_id") || h.toLowerCase().includes("question id")
//   //     );
//   //     if (idIndex !== -1) {
//   //       const extractedIds = reportDashboardData.map(row => row[idIndex]);
//   //       setQuestionIds?.(extractedIds); // Pass IDs up to parent
//   //     }
//   //   }
//   // }, [reportDashboardData, headers]);

//   const handleRemoveRow = (rowToRemove) => {
//     const questionId = rowToRemove[1]; // assuming question ID is at index 1

//     // 1. Remove from selectedQuestions
//     setSelectedQuestions((prev) => prev.filter((row) => {
//       const id = Array.isArray(row) ? row[0] : row[1];
//       return id !== questionId;
//     }));

//     // 2. Also update checkbox state in TableDetailsQuesList
//     setSelectedRows?.((prev) => prev.filter((id) => id !== questionId));
//   }

//   const handleReplaceRow = (rowToReplace) => {
//     const questionIdIndex = 1;
//     const groupIdIndex = headers.findIndex(h => h.toLowerCase().includes("group id"));
//     const currentQuesId = rowToReplace[questionIdIndex];
//     const currentGroupId = rowToReplace[groupIdIndex];
//     const selectedIds = selectedQuestions.map(row => row[questionIdIndex - 1]);
//     const sameGroupRows = allQuesList.filter(row => {
//       const match = row[28] === currentGroupId; return match;
//     });
//     const replacementCandidates = sameGroupRows.filter(row => row[0] !== currentQuesId && !selectedIds.includes(row[0]));
//     if (replacementCandidates.length === 0) {
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>No replacement found for the same Group ID.</span>
//           </div>
//         </div>
//       );
//       return;
//     }

//     const replacementRow = replacementCandidates[0];
//     const updatedQuestions = selectedQuestions.map((row) =>
//       row[0] === currentQuesId ? replacementRow : row
//     );

//     setSelectedQuestions(updatedQuestions);
//   };

// //   useEffect(() => {
// //   const fetchSelectedQuestions = async () => {
// //     if (selectedRowIds.length === 0) return;

// //     try {
// //       const response = await fetch(
// //         `${FULL_API_BASE_URL}/get-questions-by-ids`,
// //         {
// //           method: "POST",
// //           headers: {
// //             Authorization: `Bearer ${localStorage.getItem("other")}`,
// //             Accept: "application/json",
// //             "Content-Type": "application/json",
// //           },
// //           body: JSON.stringify(selectedRowIds),
// //         }
// //       );

// //       const result = await response.json();
// //       const tableData = result?.data?.table_data || [];

// //       if (tableData.length > 1) {
// //         const headers = tableData[0].map(h => h.replace(/^t\*|d\*|n\*/, ""));
// //         const rows = tableData.slice(1);
// //         setHeaders(["Section", ...headers]);
// //         setReportDashboardData(rows.map(row => ["", ...row]));
// //       }
// //     } catch (error) {
// //       console.error("Failed to fetch selected questions:", error);
// //     }
// //   };

// //   fetchSelectedQuestions();
// // }, []);

// // useEffect(() => {
// //   const fetchSelectedQuestions = async () => {
// //     const localSelectedIds = JSON.parse(localStorage.getItem("selectedRowIds") || "[]");

// //     // ✅ Get draft question IDs where status === 1
// //     const draftIds =
// //       draftData?.subjects?.flatMap((subject) =>
// //         subject.questions
// //           ?.filter((q) => q.status === 1)
// //           .map((q) => q.parse_ques_set_question_id)
// //       ) || [];

// //     // ✅ Merge and deduplicate IDs
// //     const mergedIds = Array.from(new Set([...localSelectedIds, ...draftIds]));

// //     if (mergedIds.length === 0) return;

// //     try {
// //       const response = await fetch(
// //         `${FULL_API_BASE_URL}/get-questions-by-ids`,
// //         {
// //           method: "POST",
// //           headers: {
// //             Authorization: `Bearer ${localStorage.getItem("other")}`,
// //             Accept: "application/json",
// //             "Content-Type": "application/json",
// //           },
// //           body: JSON.stringify(mergedIds),
// //         }
// //       );

// //       const result = await response.json();
// //       const tableData = result?.data?.table_data || [];

// //       if (tableData.length > 1) {
// //         const headers = tableData[0].map(h => h.replace(/^t\*|d\*|n\*/, ""));
// //         const rows = tableData.slice(1);
// //         setHeaders(["Section", ...headers]);
// //         setReportDashboardData(rows.map(row => ["", ...row]));
// //       }
// //     } catch (error) {
// //       console.error("Failed to fetch selected questions:", error);
// //     }
// //   };

// //   fetchSelectedQuestions();
// // }, [draftData]);

// const [draftLoaded, setDraftLoaded] = useState(false);

// // useEffect(() => {
// //   const fetchSelectedQuestions = async () => {
// //     const localSelectedIds = JSON.parse(localStorage.getItem("selectedRowIds") || "[]");

// //     // const draftIds =
// //     //   draftData?.subjects?.flatMap((subject) =>
// //     //     subject.questions?.filter((q) => q.status === 1).map((q) => q.parse_ques_set_question_id)
// //     //   ) || [];

// //     const draftIds = draftData?.subjects
// //     ?.find((subject) => subject.subject_id === activeSubjectId)
// //     ?.questions?.filter((q) => q.status === 1)
// //     .map((q) => q.parse_ques_set_question_id) || [];

// //     const mergedIds = Array.from(new Set([...localSelectedIds, ...draftIds]));

// //     if (mergedIds.length === 0) return;

// //     try {
// //       const response = await fetch(`${FULL_API_BASE_URL}/get-questions-by-ids`, {
// //         method: "POST",
// //         headers: {
// //           Authorization: `Bearer ${localStorage.getItem("other")}`,
// //           Accept: "application/json",
// //           "Content-Type": "application/json",
// //         },
// //         body: JSON.stringify(mergedIds),
// //       });

// //       const result = await response.json();
// //       const tableData = result?.data?.table_data || [];

// //       if (tableData.length > 1) {
// //         const headers = tableData[0].map(h => h.replace(/^t\*|d\*|n\*/, ""));
// //         const rows = tableData.slice(1);
// //         setHeaders(["Section", ...headers]);
// //         setReportDashboardData(rows.map(row => ["", ...row]));
// //         setDraftLoaded(true); // ✅ trigger downstream update
// //       }
// //     } catch (error) {
// //       console.error("Failed to fetch selected questions:", error);
// //     }
// //   };

// //   fetchSelectedQuestions();
// // }, [draftData]);

// // useEffect(() => {
// //   if (!draftData || !activeSubjectId) return;

// //   const draftSubjectQuestions =
// //     draftData?.subjects
// //       ?.find((subject) => subject.subject_id === activeSubjectId)
// //       ?.questions?.filter((q) => q.status === 1) || [];

// //   const draftSubjectIds = draftSubjectQuestions.map((q) => q.parse_ques_set_question_id);

// //   // ✅ Store in localStorage
// //   if (draftSubjectIds.length > 0) {
// //     localStorage.setItem("selectedRowIds", JSON.stringify(draftSubjectIds));
// //     // localStorage.setItem("selectedQuestions", JSON.stringify(draftSubjectQuestions));
// //   }
// // }, [draftData, activeSubjectId]);

// // useEffect(() => {
// //   const fetchSelectedQuestions = async () => {
// //     const allLocalSelected = JSON.parse(localStorage.getItem("selectedQuestions") || "[]");
// //     const allLocalSelectedIds = JSON.parse(localStorage.getItem("selectedRowIds") || "[]");

// //     // ✅ Filter local questions by subject
// //     const localSubjectQuestions = allLocalSelected.filter(
// //       (q) => q.subject_id === activeSubjectId
// //     );
// //     const localSubjectIds = allLocalSelectedIds.filter(
// //       (id) => localSubjectQuestions.some((q) => q.parse_ques_set_question_id === id)
// //     );

// //     // ✅ Filter draft questions by subject
// //     const draftSubjectQuestions =
// //       draftData?.subjects
// //         ?.find((subject) => subject.subject_id === activeSubjectId)
// //         ?.questions?.filter((q) => q.status === 1) || [];
// //     const draftSubjectIds = draftSubjectQuestions.map((q) => q.parse_ques_set_question_id);

// //     // console.log(draftSubjectIds, "draftSubjectQuestions");

// //     // ✅ Merge IDs without duplicates
// //     const mergedIds = Array.from(new Set([...localSubjectIds, ...draftSubjectIds]));
// //     console.log(mergedIds, "mergedIds");

// //     if (mergedIds.length === 0) return;

// //     try {
// //       const response = await fetch(
// //         `${FULL_API_BASE_URL}/get-questions-by-ids`,
// //         {
// //           method: "POST",
// //           headers: {
// //             Authorization: `Bearer ${localStorage.getItem("other")}`,
// //             Accept: "application/json",
// //             "Content-Type": "application/json",
// //           },
// //           body: JSON.stringify(mergedIds),
// //         }
// //       );

// //       const result = await response.json();
// //       const tableData = result?.data?.table_data || [];

// //       if (tableData.length > 1) {
// //         const headers = tableData[0].map((h) => h.replace(/^t\*|d\*|n\*/, ""));
// //         const rows = tableData.slice(1);

// //         setHeaders(["Section", ...headers]);
// //         setReportDashboardData(rows.map((row) => ["", ...row]));
// //         setDraftLoaded(true); // ✅ trigger downstream update
// //       }
// //     } catch (error) {
// //       console.error("Failed to fetch selected questions:", error);
// //     }
// //   };

// //   fetchSelectedQuestions();
// // }, [draftData, activeSubjectId]);

// // ✅ Store draft question IDs in localStorage without overwriting
// // useEffect(() => {
// //   if (!draftData || !activeSubjectId) return;

// //   const draftSubjectQuestions =
// //     draftData?.subjects
// //       ?.find((subject) => subject.subject_id === activeSubjectId)
// //       ?.questions?.filter((q) => q.status === 1) || [];

// //   const draftSubjectIds = draftSubjectQuestions.map((q) => q.parse_ques_set_question_id);

// //   const existingIds = JSON.parse(localStorage.getItem("selectedRowIds") || "[]");

// //   const mergedIds = Array.from(new Set([...existingIds, ...draftSubjectIds]));

// //   localStorage.setItem("selectedRowIds", JSON.stringify(mergedIds));
// // }, [draftData, activeSubjectId]);

// // ✅ Fetch and merge selected questions by subject
// useEffect(() => {
//   const fetchSelectedQuestions = async () => {
//     // const allLocalSelected = JSON.parse(localStorage.getItem("selectedRowIds") || "[]");

//     // // ✅ Filter local questions by subject
//     // const localSubjectQuestions = allLocalSelected.filter(
//     //   (q) => q.subject_id === activeSubjectId
//     // );
//     // const localSubjectIds = localSubjectQuestions.map((q) => q.parse_ques_set_question_id);
//     const subjectWiseSelected = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//     const localSubjectIds = subjectWiseSelected[activeSubjectId] || [];

//     // ✅ Filter draft questions by subject
//     const draftSubjectQuestions =
//       draftData?.subjects
//         ?.find((subject) => subject.subject_id === activeSubjectId)
//         ?.questions?.filter((q) => q.status === 1) || [];
//     const draftSubjectIds = draftSubjectQuestions.map((q) => q.parse_ques_set_question_id);

//     // ✅ Merge IDs without duplicates
//     const mergedIds = Array.from(new Set([...localSubjectIds, ...draftSubjectIds]));
//     console.log(mergedIds, "mergedIds");
//     // const mergedIds = Array.from(new Set([...localSubjectIds]));
//     if (mergedIds.length === 0) return;

//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-questions-by-ids`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("other")}`,
//             Accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(mergedIds),
//         }
//       );

//       const result = await response.json();
//       const tableData = result?.data?.table_data || [];

//       if (tableData.length > 1) {
//         const headers = tableData[0].map((h) => h.replace(/^t\*|d\*|n\*/, ""));
//         const rows = tableData.slice(1);

//         setHeaders(["Section", ...headers]);
//         setReportDashboardData(rows.map((row) => ["", ...row]));
//         // const mergedRows = rows.map((row) => ["", ...row]);
//         // setReportDashboardData(mergedRows);

//         // // ✅ Update selectedQuestions state as well
//         // setSelectedQuestions((prev) => {
//         //   // avoid duplicating same ID
//         //   const existingIds = new Set(prev.map((r) => (Array.isArray(r) ? r[0] : r[1])));
//         //   const newUnique = mergedRows.filter((row) => !existingIds.has(row[1]));
//         //   return [...prev, ...newUnique];
//         // });

//         // ✅ Store fetched question IDs back to localStorage
//         const allIds = rows.map((row) => row[0]);
//         // const existing = JSON.parse(localStorage.getItem("selectedRowIds") || "[]");
//         // const merged = Array.from(new Set([...existing, ...allIds]));
//         // localStorage.setItem("selectedRowIds", JSON.stringify(merged));
//         const existing = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//         const updated = {
//           ...existing,
//           [activeSubjectId]: Array.from(new Set([...(existing[activeSubjectId] || []), ...allIds])),
//         };

//         localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(updated));
//         setDraftLoaded(true);
//       }
//     } catch (error) {
//       console.error("Failed to fetch selected questions:", error);
//     }
//   };

//   fetchSelectedQuestions();
// }, [draftData, activeSubjectId]);

// useEffect(() => {
//   if (!reportDashboardData || reportDashboardData.length === 0 || !draftLoaded) return;

//   const difficultyIndex = headers.findIndex(h =>
//     h.toLowerCase().includes("difficulty level")
//   );

//   const difficultyCount = { easy: 0, medium: 0, tough: 0 };

//   reportDashboardData.forEach(row => {
//     const diff = row[difficultyIndex]?.toLowerCase();
//     if (["easy", "medium", "tough"].includes(diff)) {
//       difficultyCount[diff]++;
//     }
//   });

//   setDifficultyCount?.(difficultyCount);
// }, [reportDashboardData, headers, draftLoaded]);

// // useEffect(() => {
// //   if (!selectedQuestions || selectedQuestions.length === 0) return;

// //   const selectedIds = selectedQuestions.map((row) =>
// //     Array.isArray(row) ? row[0] : row[1]
// //   );

// //   const storedIds = JSON.parse(localStorage.getItem("selectedRowIds") || "[]");

// //   const mergedIds = Array.from(new Set([...storedIds, ...selectedIds]));
// //   localStorage.setItem("selectedRowIds", JSON.stringify(mergedIds));
// // }, [selectedQuestions]);

//   return (
//     <div style={{ height: "auto", width: "100%", }} >
//       <div style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
//         <div>
//           <TableComponent
//             headers={headers}
//             data={reportDashboardData}
//             searchPlaceholder="Filter Questions..."
//             dataClient={dataClient}
//             setPagePath={setPagePath}
//             renderQuestionText={renderQuestionText}
//             selectedRows={selectedRows}
//             setSelectedRows={setSelectedRows}
//             handleRemoveRow={handleRemoveRow}
//             selectedSections={selectedSections}
//             setIsMessageBoxVisible={setIsMessageBoxVisible}
//             setMessageBox={setMessageBox}
//             setActiveImg={setActiveImg}
//             setSectionWiseQuestions={setSectionWiseQuestions}
//             selecteSectionTypeID={selecteSectionTypeID}
//             setQuestionIds={setQuestionIds}
//             tableQuestions={tableQuestions}
//             allQuesList={allQuesList}
//             handleReplaceRow={handleReplaceRow}
//             renderQuestionTextTable={renderQuestionTextTable}
//             selectedSectionPerRow={selectedSectionPerRow}
//             setSelectedSectionPerRow={setSelectedSectionPerRow}
//             isReadOnlyMode={isReadOnlyMode}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TableDetailsSelectedQuestions;

// const handleRemoveRow = (rowToRemove) => {
//   const questionId = rowToRemove[1]; // assuming question ID is at index 1

//   // 1. Remove from selectedQuestions
//   const updatedQuestions = selectedQuestions.filter((row) => {
//     const id = Array.isArray(row) ? row[0] : row[1];
//     return id !== questionId;
//   });

//   setSelectedQuestions(updatedQuestions);

//   // 2. Remove from localStorage
//   const stored = JSON.parse(localStorage.getItem("selectedQuestions") || "[]");
//   const updatedStorage = stored.filter((row) => row[0] !== questionId);
//   localStorage.setItem("selectedQuestions", JSON.stringify(updatedStorage));

//   // 3. Update reportDashboardData state (the table display)
//   setReportDashboardData((prev) =>
//     prev.filter((row) => row[1] !== questionId)
//   );

//   // 4. Update checkbox state in TableDetailsQuesList if needed
//   setSelectedRows?.((prev) => prev.filter((id) => id !== questionId));
// };

// useEffect(() => {
//   const storedQuestions = JSON.parse(localStorage.getItem("selectedQuestions") || "[]");
//   const storedHeaders = JSON.parse(localStorage.getItem("selectedHeaders") || "[]");
//   if (!storedQuestions.length) return;

//   const headersWithSection = storedHeaders.includes("Section")
//     ? storedHeaders
//     : ["Section", ...storedHeaders];

//   const transformedRows = storedQuestions.map((row) => ["", ...row]);

//   setHeaders(headersWithSection);
//   setReportDashboardData(transformedRows);

//   const idIndex = headersWithSection.findIndex((h) =>
//     h.toLowerCase().includes("question id")
//   );
//   const ids = transformedRows.map((row) => row[idIndex]);
//   setQuestionIds?.(ids);
// }, [selectedQuestions]);

//   useEffect(() => {
//   const storedQuestions = JSON.parse(localStorage.getItem("selectedQuestions") || "[]");
//   const storedHeaders = JSON.parse(localStorage.getItem("selectedHeaders") || "[]");

//   if (!storedQuestions.length) return;

//   const headersWithSection = storedHeaders.includes("Section")
//     ? storedHeaders
//     : ["Section", ...storedHeaders];

//   const transformedRows = storedQuestions.map((row) => ["", ...row]);

//   setHeaders(headersWithSection);
//   setReportDashboardData(transformedRows);

//   const idIndex = headersWithSection.findIndex((h) =>
//     h.toLowerCase().includes("question id")
//   );
//   const ids = transformedRows.map((row) => row[idIndex]);
//   setQuestionIds?.(ids);
// }, [selectedQuestions]); // <-- Add dependency here
